import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Smile, Sparkles } from 'lucide-react';
export function DemoSection() {
  return <section className="py-24 bg-[#0a0a1a] relative overflow-hidden" data-id="element-46">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-47" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-48">
        <div className="text-center mb-16" data-id="element-49">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-50">
            Tus Clientes,{' '}
            <span className="text-gradient-cosmic" data-id="element-51">Felices y Confiados</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-52">
            Creamos presencia digital que transmite la misma confianza y
            profesionalismo que tus clientes sienten cuando trabajan con vos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-53">
          {/* First Image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="relative rounded-2xl overflow-hidden border border-white/10 group" data-id="element-54">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-55">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Profesional atendiendo a su cliente" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-56" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-[#050510]/20 to-transparent" data-id="element-57" />
            <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-58">
              <div className="flex items-center gap-2 mb-2" data-id="element-59">
                <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center" data-id="element-60">
                  <Smile className="w-4 h-4 text-cyan-400" data-id="element-61" />
                </div>
                <span className="text-xs font-bold text-cyan-400 uppercase tracking-wider" data-id="element-62">
                  Servicios Profesionales
                </span>
              </div>
              <h3 className="text-xl font-bold text-white font-orbitron" data-id="element-63">
                Confianza desde el primer contacto
              </h3>
              <p className="text-sm text-gray-400 mt-1" data-id="element-64">
                Mostrá tus servicios con una página web que refleje la calidad
                de tu trabajo.
              </p>
            </div>
          </motion.div>

          {/* Second Image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="relative rounded-2xl overflow-hidden border border-white/10 group" data-id="element-65">
            <div className="aspect-[4/3] overflow-hidden" data-id="element-66">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Equipo profesional trabajando" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-67" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-[#050510]/20 to-transparent" data-id="element-68" />
            <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-69">
              <div className="flex items-center gap-2 mb-2" data-id="element-70">
                <div className="w-8 h-8 rounded-full bg-pink-500/20 flex items-center justify-center" data-id="element-71">
                  <Sparkles className="w-4 h-4 text-pink-400" data-id="element-72" />
                </div>
                <span className="text-xs font-bold text-pink-400 uppercase tracking-wider" data-id="element-73">
                  Resultados Reales
                </span>
              </div>
              <h3 className="text-xl font-bold text-white font-orbitron" data-id="element-74">
                Resultados que se ven
              </h3>
              <p className="text-sm text-gray-400 mt-1" data-id="element-75">
                Mostrá tu experiencia y resultados para que tus clientes vean lo
                que pueden lograr con vos.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-8 mt-12 max-w-3xl mx-auto" data-id="element-76">
          {[{
          value: '+40%',
          label: 'Más clientes captados'
        }, {
          value: '5 días',
          label: 'Tiempo de entrega'
        }, {
          value: '24/7',
          label: 'Tu página trabaja por vos'
        }].map((stat, i) => <div key={i} className="text-center" data-id="element-77">
              <div className="text-2xl md:text-3xl font-bold text-gradient-cosmic font-orbitron" data-id="element-78">
                {stat.value}
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-79">{stat.label}</div>
            </div>)}
        </motion.div>

        <div className="mt-12 text-center" data-id="element-80">
          <a href="#precios" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold transition-all duration-300" data-id="element-81">
            Quiero una página así para mi negocio{' '}
            <ExternalLink className="w-4 h-4" data-id="element-82" />
          </a>
        </div>
      </div>
    </section>;
}